import React from 'react';

const DodgeLogo = ({ size = 60 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    role="img"
    aria-label="Dodge The Falling Blocks logo"
  >
    <defs>
      <linearGradient id="dodgeGradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0da27e" />
        <stop offset="1" stopColor="#20c59a" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="14" fill="#0b1f2d" />
    <path d="M14 22h36L38 42H14z" fill="url(#dodgeGradient)" />
    <circle cx="46" cy="16" r="6" fill="#ff8f4f" />
  </svg>
);

export default DodgeLogo;
